<h1 mat-dialog-title>
    <span style="position: relative; top: 4px">
  @if (hotkeyMode === 'slide') {
      <mat-icon>slideshow</mat-icon>
  } @else {
      <mat-icon>dashboard</mat-icon>
  }
    </span>
    {{ 'general.' + hotkeyMode | transloco }} {{ 'general.shortKeys' | transloco }}
</h1>
<div mat-dialog-content [class.slide-mode]="hotkeyMode === 'slide'">
    @for (group of hotkeys; track group) {
        <div>
            @if (group.group) {
                <div style="margin-top: 10px; font-weight: bold;">{{ group.group }}</div>
            }
            <div style="padding: 10px; width: 100%;">
                @for (item of group['keys']; track item) {
                    @if (!item.hidden) {
                        <div class="short-key">
                            <span class="hotkey-description" [innerHTML]="item.description"></span>
                            <span class="hotkey-cmd" [innerHTML]="item.key"></span>
                        </div>
                    }
                }
            </div>
        </div>
    }
</div>
